import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { useDatesContext } from "./auth-service-tools577.js";
import { getWeekdayNames } from "./auth-service-tools582.js";
import classes from "./auth-service-tools583.js";
import { factory } from "./auth-service-tools248.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { getFontSize, getSpacing } from "./auth-service-tools185.js";
const defaultProps = {};
const varsResolver = createVarsResolver((_, _ref) => {
  let {
    size
  } = _ref;
  return {
    weekdaysRow: {
      "--wr-fz": getFontSize(size),
      "--wr-spacing": getSpacing(size)
    }
  };
});
const WeekdaysRow = factory((_props, ref) => {
  const props = useProps("WeekdaysRow", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    locale,
    firstDayOfWeek,
    weekdayFormat,
    cellComponent: CellComponent = "th",
    __staticSelector,
    ...others
  } = props;
  const getStyles = useStyles({
    name: __staticSelector || "WeekdaysRow",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver,
    rootSelector: "weekdaysRow"
  });
  const ctx = useDatesContext();
  const weekdays = getWeekdayNames({
    locale: ctx.getLocale(locale),
    format: weekdayFormat,
    firstDayOfWeek: ctx.getFirstDayOfWeek(firstDayOfWeek)
  }).map((weekday, index) => /* @__PURE__ */jsxRuntimeExports.jsx(CellComponent, { ...getStyles("weekday"),
    children: weekday
  }, index));
  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
    component: "tr",
    ref,
    ...getStyles("weekdaysRow"),
    ...others,
    children: weekdays
  });
});
WeekdaysRow.classes = classes;
WeekdaysRow.displayName = "@mantine/dates/WeekdaysRow";
export { WeekdaysRow };